<template>
    <div
        class="stream-ended-container"
    >
        <SdsIllustration illustrationName="video" />
        <p>Event has ended.</p>
        <p>Closing stream in {{ timer }}s</p>
    </div>
</template>

<script>
    import { SdsIllustration } from '@superbet-group/web.lib.ui-components';
    import { mapActions } from 'vuex';

    export default {
        data() {
            return { timer: null, countdownInterval: null };
        },
        mounted() {
            this.startCountdown();
        },
        watch: {
            timer(value) {
                if (value === 0) {
                    this.toggleSelectedStreamSection(null);
                }
            },
        },
        methods: {
            ...mapActions('ui/sportOffer', [
                'toggleSelectedStreamSection',
            ]),
            startCountdown() {
                this.timer = 60;

                this.countdownInterval = setInterval(() => {
                    this.timer = this.timer - 1;
                }, 1000);
            },
        },
        beforeDestroy() {
            clearInterval(this.countdownInterval);
        },
        components: {
            SdsIllustration,
        },
    };
</script>
